<template>
    <ajax-table :data="data"
                :headers="headers"
                v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                :exportable="false"
                @loadData="fetchLoginAttempts"
                no-data-message="No login attempts found"
    >

        <!-- Column 1: Display Name-->
        <template #col-1="props">
            <div class="flex flex-col items-start justify-center">
        <span class="my-1 text-gray-700">
          <div class="font-medium text-gray-900">{{ props.row.display_name_with_email }}</div>
        </span>
            </div>
        </template>

        <!-- Column 2: IP Address-->
        <template #col-2="props">
            <div class="flex flex-col items-start justify-center">
        <span class="my-1 text-gray-700">
          <div class="font-medium text-gray-900">{{ props.row.ip_address }}</div>
        </span>
            </div>
        </template>

        <!-- Column 3: Date-->
        <template #col-3="props">
            <div class="flex flex-col items-start justify-center">
        <span class="my-1 text-gray-700">
          <div class="font-medium text-gray-900">{{ props.row.login_at }}</div>
        </span>
            </div>
        </template>

        <!-- Column 4: Status-->
        <template #col-4="props">
            <div class="flex flex-col items-start justify-center">
        <span class="my-1 text-gray-700">
          <div class="font-medium text-gray-900">{{ props.row.success }}</div>
        </span>
            </div>
        </template>

    </ajax-table>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import axios from "axios";
import _ from "lodash";
export default {
    name: 'LoginAttempts',
    components: {AjaxTable},
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    data() {
        return {
            data: [],
            headers: [
                {name: 'Display Name', key: 'user.display_name'},
                {name: 'IP Address', key: 'ip_address'},
                {name: 'Date', key: 'login_at'},
                {name: 'Status', key: 'success'},
            ],
            requestNumber: 0
        }
    },
    mounted() {
        this.fetchLoginAttempts();
    },
    methods: {
        fetchLoginAttempts() {
            this.ajaxTable.loading = true;
            this.requestNumber++;
            let params = JSON.parse(JSON.stringify(this.ajaxTable));
            params.requestNumber = this.requestNumber;
            axios.get(this.company.buildCompanyApiInternalRoute('login-attempts'),
                {
                    params: params
                }
            )
                .then(response => {
                    let data = response.data;

                    // Extract the user.display_name from the user object
                    data.data = data.data.map(item => ({
                        ...item,
                        display_name_with_email: `${item.user.display_name} (${item.user.email})`
                    }));

                    this.ajaxUpdateTableData(data);
                    this.data = !_.isNil(data.data) ? data.data : [];
                })
                .then(() => {
                    this.ajaxTable.loading = false;
                })
        }
    }
}
</script>